var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ourTechApproach_videoContainer",attrs:{"data-scroll":"","data-scroll-id":"approachVideo","data-scroll-offset":"0,0"}},[_c('div',{ref:"lottieEl",staticClass:"ourTechApproach_lottie"})])}
var staticRenderFns = []

export { render, staticRenderFns }